import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Image,
} from '@joinrepublic/dls-ui-kit';

import { colors, containerSize } from '../../config/styles';
import { MotionBox } from '../motion-box/motion-box';
import { SecondaryMarketDeals } from '../secondary-market-deals/secondary-market-deals';
import picLogos from './assets/pic-logos.png';

const MARKETPLACE_URL =
  'https://europe.republic.com/invest/marketplace?sort=performance_desc&sort_collection=businesses';

export const SecondaryMarket = () => {
  return (
    <Box
      as="section"
      mt={{ base: '14', sm: '16' }}
      mb={{ base: '16', sm: '28' }}
    >
      <Container maxW={containerSize}>
        <MotionBox mb={{ base: '10', sm: '14' }}>
          <Flex
            as="header"
            direction={{ base: 'column', sm: 'row' }}
            justify="space-between"
            alignItems="center"
            gap="10"
          >
            <Box order={{ base: '1', sm: '0' }} pr={{ base: '0', sm: '12' }}>
              <Heading
                as="h2"
                mt="0"
                maxW="650px"
                size="title-md"
                color={colors.darkNavyTypography}
              >
                Buy, sell, and trade your private shares on our 24/7 secondary
                market
              </Heading>

              <Box mt={{ base: '7', lg: '12' }}>
                <Button
                  as="a"
                  href={MARKETPLACE_URL}
                  target="_blank"
                  size="default"
                  variant="secondary"
                  px="10"
                  py="4"
                  w={{ base: 'full', sm: 'auto' }}
                >
                  Get started
                </Button>
              </Box>
            </Box>

            <Box flexShrink="0" pr={{ base: '0', md: '8' }}>
              <Image
                src={picLogos}
                alt="Company logos"
                h={{ base: '170px', lg: '228px' }}
              />
            </Box>
          </Flex>
        </MotionBox>

        <MotionBox delay={0.2}>
          <SecondaryMarketDeals />
        </MotionBox>
      </Container>
    </Box>
  );
};
